<template>
  <div class="contents4">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <div class="text1">서울 오피스 오시는길</div>
      <div class="map">
        <gmap-map id="map" :center="map.center" :zoom="map.zoom">
          <gmap-marker :position="markers.position" :icon="markers.icon"> </gmap-marker>
        </gmap-map>
      </div>
      <div class="text2">
        <div class="left">
          <div class="wrap">
            <div class="title">가산점 사옥</div>
            <div class="body">
              서울시 금천구 디지털로 9길 68<br />
              대륭포스트타워 5차 1106호
            </div>
          </div>
        </div>
        <div class="right">
          <div class="wrap">
            <p>
              <span>TEL.</span> 1600.0222<br />
              <span>FAX.</span> 02.2624.3360
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {
      isMobile: false,
      bgImg: 'static/img/intro-content/contents4.png',
      map: {
        center: {
          lat: 37.48113557199069,
          lng: 126.88635659670153
        },
        zoom: 18
      },
      markers: {
        position: {
          lat: 37.48113557199069,
          lng: 126.88635659670153
        },
        icon: {
          url: 'static/img/intro-content/marker.png'
        }
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/intro-content/contents4.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/intro-content/contents4.png'
        this.isMobile = true
      }
    }
  }
}
</script>

<style scoped>
.contents4 {
  width: 100%;
  position: relative;
}
.contents4 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 33px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 .left .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 29px;
    color: #000000;
    margin-bottom: 7%;
  }
  .text2 .left .body {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .text2 .right p {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .text2 .right span {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.6vw;
    line-height: 3.6vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text2 .left .title {
    font-style: normal;
    font-weight: bold;
    font-size: 1.4vw;
    line-height: 2.2vw;
    color: #000000;
    margin-bottom: 7%;
  }
  .text2 .left .body {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .text2 .right p {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .text2 .right p span {
    font-style: normal;
    font-weight: bold;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #000000;
  }
}
@media (min-width: 641px) {
  .contents4 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5% 0 0 0;
    text-align: center;
  }
  .contents4 .map {
    width: 100%;
    height: 50%;
  }
  .contents4 .map >>> #map {
    width: 100%;
    height: 100%;
  }
  .text2 {
    display: flex;
    width: 100%;
  }
  .text2 .left {
    margin-top: 2%;
    width: 50%;
    display: flex;
    justify-content: center;
  }
  .text2 .left .wrap,
  .text2 .right .wrap {
    text-align: left;
  }
  .text2 .right {
    margin-top: 6%;
    width: 50%;
    display: flex;
    justify-content: flex-start;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents4 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .contents4 .map {
    width: 100%;
    height: 50%;
  }
  .contents4 .map >>> #map {
    width: 100%;
    height: 100%;
  }
  .text2 {
    width: 100%;
    padding: 10% 0 0 5%;
  }
  .text2 .left {
    width: 100%;
    margin-bottom: 5%;
  }
  .text2 .left .wrap,
  .text2 .right .wrap {
    text-align: left;
  }
  .text2 .right {
    width: 100%;
  }
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 8vw;
    color: #000000;
    margin-top: 20%;
    margin-bottom: 15%;
  }
  .text2 .left .title {
    font-style: normal;
    font-weight: bold;
    font-size: 4.5vw;
    line-height: 6vw;
    color: #000000;
    margin-bottom: 8%;
  }
  .text2 .left .body {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 6vw;
    color: #444444;
  }
  .text2 .right p {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 6vw;
    color: #444444;
  }
  .text2 .right p span {
    font-style: normal;
    font-weight: bold;
    font-size: 4vw;
    line-height: 6vw;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/intro/Contents3.vue